module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gb-84d4bb24d2a1a5891e0d89c4c3cdda82.svg";